import api from "./api";
export const getDashboardStats = async (userRole) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return { 
        success: false, 
        message: 'No authentication token found' 
      };
    }

    const endpoint = userRole?.toLowerCase() === 'admin' 
      ? '/admin/dashboard' 
      : '/employee/dashboard';
    const response = await api.get(endpoint, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      validateStatus: function (status) {
        return status < 500; // Don't throw errors for 4xx responses
      }
    });

    if (response.status === 401) {
      return { 
        success: false, 
        message: 'Authentication failed' 
      };
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Dashboard service error:', error);
    return {
      success: false,
      message: error.response?.data?.error || 'Failed to fetch dashboard data'
    };
  }
};